export interface HistoryLookupModel {
  carrierVisitNames: { [key: string]: string } | null
  containerNumbers: { [key: string]: string } | null
  customerNames: { [key: string]: string } | null
  userNames: { [key: string]: string } | null
  gangNames: { [key: string]: string } | null
  shiftNames: { [key: string]: string } | null
}

export interface HistoryLookupConfig {
  fieldPath: string
  sourceName: keyof HistoryLookupModel
}

export enum HistoryEventType {
  ContainerPositionChanged = 'ContainerPositionChanged',
  ContainerMoved = 'ContainerMoved',
  ContainerOrderUpsertedEvent = 'ContainerOrderUpsertedEvent',
  ContainerUpserted = 'ContainerUpserted',
}

export interface HistoryEventConfig {
  eventType: HistoryEventType
  eventTitle?: string
  hiddenFields?: string[]
  showOnlyNewFields?: string[]
  dateFormatFields?: string[]
  lookupConfig?: HistoryLookupConfig[]
  locationField?: string
}

export interface EventDifferenceModel {
  title?: string | null
  previousValue?: string | null
  newValue?: string | null
}

const alwaysHiddenFields = ['.Id', '.TenantId', '.Oid']

export const historyEventConfigList: HistoryEventConfig[] = [
  {
    eventType: HistoryEventType.ContainerPositionChanged,
    hiddenFields: [...alwaysHiddenFields, '.OrderId'],
    locationField: '.UpdatedLocation',
    lookupConfig: [
      {
        fieldPath: '.UserId',
        sourceName: 'userNames',
      },
    ],
  },
  {
    eventType: HistoryEventType.ContainerUpserted,
    hiddenFields: [...alwaysHiddenFields],
  },
  {
    eventType: HistoryEventType.ContainerMoved,
    hiddenFields: [
      ...alwaysHiddenFields,
      '.HandlingDirection',
      '.MovementData.RailcarTrackPositionId',
      '.OrderId',
    ],
    showOnlyNewFields: ['.PrevPosition', '.CurrentPosition', '.GangId', '.ShiftId'],
    lookupConfig: [
      {
        fieldPath: '.UserId',
        sourceName: 'userNames',
      },
      {
        fieldPath: '.GangId',
        sourceName: 'gangNames',
      },
      {
        fieldPath: '.ShiftId',
        sourceName: 'shiftNames',
      },
    ],
  },
  {
    eventType: HistoryEventType.ContainerOrderUpsertedEvent,
    hiddenFields: [...alwaysHiddenFields, '.Status', '.CarrierVisitGuid'],
    showOnlyNewFields: ['.ClosedAt', '.IsEmpty'],
    dateFormatFields: ['.ClosedAt'],
    lookupConfig: [
      {
        fieldPath: '.CarrierVisitId',
        sourceName: 'carrierVisitNames',
      },
      {
        fieldPath: '.ContainerId',
        sourceName: 'containerNumbers', //TODO: is not implemented yet
      },
      {
        fieldPath: '.CustomerId',
        sourceName: 'customerNames', //TODO: is not implemented yet
      },
    ],
  },
]
